import React from 'react';
import { useSelector } from 'react-redux';
import {
  HotelElement as SharedHotelElement,
  HotelElementProps,
} from '@skygroup/shared/components/hotel-autocomplete-element/HotelElement';
import { RootState } from '../../../../store/store';

export const HotelElement = (props: Omit<HotelElementProps, 'skyInventoryLabel'>) => {
  const { shoppingCartTranslations: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  return <SharedHotelElement {...props} skyInventoryLabel={t?.skyInventory} />;
};
